'use client';
import React, { useEffect, useState } from 'react';
import loadBackgroudImages from '../../common/loadBackgroudImages';
import { getAllPortfolios } from '../../common/portfolioStore';

function Header() {
  const [portfolioCount, setPortfolioCount] = useState(null);

  useEffect(() => {
    loadBackgroudImages();
    getAllPortfolios()
      .then((data) => setPortfolioCount(data.length))
      .catch(() => setPortfolioCount(0));
  }, []);

  return (
    <header
      className=" main-header bg-img valign"
      data-background="/assets/imgs/background/bg5.jpg"
      data-overlay-dark="7"
    >
      <div className="container ontop">
        <div className="row">
          <div className="col-lg-11">
            <div className="caption">
              <h1>Dijital dünyada</h1>
              <div className="d-flex align-items-end">
                <div>
                  <h1 className="nowrap">
                    <span className="main-color">güçlü</span> varlık.
                  </h1>
                </div>
                <div>
                  <div className="text ml-30">
                    <p>
                      İşletmenizi dijital dünyaya taşıyoruz. Web tasarım,
                      yazılım geliştirme ve{' '}
                      <span className="text-light fw-600">
                        dijital pazarlama
                      </span>{' '}
                      alanlarında yenilikçi çözümler sunuyoruz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row mt-80">
          <div className="col-lg-6 order-md-2">
            <div className="icon-img">
              <img src="/assets/imgs/icon-img/arrow-down-big.png" alt="" />
            </div>
          </div>
          <div className="col-lg-6 d-flex justify-content-end order-md-1">
            <div className="info">
              <h2 className="mb-10">
                {portfolioCount !== null ? `${portfolioCount}+` : '...'}
              </h2>
              <h6>
                Yayındaki <br />
                <span className="main-color">proje</span>
              </h6>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
